module.exports = __webpack_public_path__ + "img/ico-gear.83f072a2.svg";